module.exports = __webpack_public_path__ + "static/media/background_640-3.55e47e98.jpg";